import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { ChevronDown, MessageCircle, ArrowRight } from "lucide-react"
import "./Faqs.css"

const Faqs = ({ countryData }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const toggleFaq = (index) => setActiveIndex(activeIndex === index ? null : index)

  const faqs = countryData?.faqs || []

  return (
    <div className="faqs-container">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Frequently Asked Questions
      </motion.h1>

      <div className="faqs-content">
        <div className="faqs-list">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              viewport={{ once: true }}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
            >
              <div className="faq-question" onClick={() => toggleFaq(index)}>
                <h3>{faq.question}</h3>
                <motion.span
                  className="faq-icon"
                  animate={{ rotate: activeIndex === index ? 180 : 0 }}
                >
                  <ChevronDown size={24} />
                </motion.span>
              </div>
              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="faq-answer"
                  >
                    <div className="faq-answer-inner">
                      <p>{faq.answer}</p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="faqs-illustration"
        >
          <img
            src="https://img.freepik.com/free-vector/questions-concept-illustration_114360-1513.jpg"
            alt="FAQ Illustration"
            className="faq-image"
          />
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="contact-section"
      >
        <h2>Still have questions?</h2>
        <p>
          Our expert counselors are here to help you navigate every step of your journey in {countryData?.name}.
        </p>
        <a href="#contact" className="contact-btn">
          Consult our Experts <ArrowRight size={20} />
        </a>
      </motion.div>
    </div>
  )
}

export default Faqs
